<template>
  <SNightCardManagementPanel
    :profile="getUserProfile"
    :info-link-url="nightCardProgramInfoUrl"
    @populateUserProfileInfo="populateUserProfileInfo"
    @setGlobalLoading="setGlobalLoading"
  />
</template>

<script lang="ts">
export default {
  name: 'SettingsNightCard',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import appConfig from '@/appConfig';
import resolveNightCardProgramInfoUrl from '@/utils/resolveNightCardProgramInfoUrl';
import { SNightCardManagementPanel } from '@slg/web-customer-shared';
import { useStore, useI18n, useGlobalErrorDialog } from '@/composables';

const store = useStore();
const { i18n } = useI18n();
const { setGlobalError } = useGlobalErrorDialog();

const getUserProfile = computed(() => store.getters['auth/getUserProfile']);
const nightCardProgramInfoUrl = computed(() => resolveNightCardProgramInfoUrl(
  appConfig.nightCardProgramInfoUrl,
  i18n.locale,
  appConfig,
));

function setGlobalLoading(loadingState: boolean) {
  store.commit('common/setGlobalLoading', loadingState);
}

async function populateUserProfileInfo() {
  try {
    await store.dispatch('auth/populateUserProfileInfo');
  } catch (e) {
    await setGlobalError(e as any);
  }
}
</script>
